export default __webpack_public_path__ + "static/media/ayush2.321a32aa.jpg";